enum ViewOption {
  ALL = 'All',
  LISTENING_TO = 'Listening To',
  NONE = 'None',
}

export default ViewOption;
